import { getDocs, query, where } from "firebase/firestore";
import { RepositoryFirebase } from "../common/repository.firebase";
import { CreditTransaction } from "./credit-transaction.entity";

class CreditTransactionRepository extends RepositoryFirebase<CreditTransaction> {
  protected collection = "credit-transactions";
  protected entity = CreditTransaction;

  async listByCustomerId(customerId: string) {
    const q = query(
      this.getCollection(),
      where("customerId", "==", customerId)
    );
    const snap = await getDocs(q);
    const items = await Promise.all(
      snap.docs.map((d) => CreditTransaction.build(d.id, d.data()))
    );
    return items.sort(
      (a, b) => b.getCreatedAt().valueOf() - a.getCreatedAt().valueOf()
    );
  }
}

export const creditTransactionRepository = new CreditTransactionRepository();
